module.exports = __webpack_public_path__ + "img/about.c4ab39ef.svg";